export default {"src":"/_next/static/media/BITCOINCOM_LOGO.5bcf7198.svg","height":14,"width":95,"blurWidth":0,"blurHeight":0};